import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { services } from "../data/content";

export default function Services() {
  return (
    <main className="bg-ink min-h-screen pt-32 pb-16">
      <div className="max-w-6xl mx-auto px-6">
        <p className="text-brand-500 font-medium mb-2">What we do</p>
        <h1 className="font-display text-4xl md:text-5xl font-bold text-neutral-900" data-testid="services-heading">
          Construction & Renovation Services
        </h1>
        <p className="text-neutral-500 mt-3 max-w-2xl">
          A comprehensive range of premium construction and renovation services for
          modern spaces — delivered by Nayan Enterprises across Pune.
        </p>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-12">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.06 }}
              className="group bg-surface border border-neutral-200 rounded-2xl overflow-hidden shadow-card hover:-translate-y-1 transition-transform"
              data-testid={`service-card-${i}`}
            >
              <div className="h-48 overflow-hidden">
                <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <span className="text-xs font-semibold uppercase tracking-wide text-brand-500">{s.category}</span>
                <h3 className="text-xl font-bold text-neutral-900 mt-1 mb-2">{s.title}</h3>
                <p className="text-neutral-500 text-sm">{s.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 rounded-3xl bg-gradient-to-r from-brand-500 to-brand-600 p-10 md:p-14 text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-white">Need a quote for your project?</h2>
          <p className="text-white/80 mt-3">Reach out and our team will get back within 24 hours.</p>
          <Link to="/contact" className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-white text-neutral-900 font-semibold rounded-full hover:scale-105 transition-transform">
            Get a Quote <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </main>
  );
}
